<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-0 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
      :locale="{ emptyText: emptyTemplate }"
    >
      <div
        slot="codigo_queja"
        class="title-size font-bold text-gray-500 text-center"
      >
        Codigo queja
      </div>

      <div slot="nameEv" class="title-size font-bold text-gray-500 text-center">
        Entidad vigilada
      </div>
      <div
        slot="reason_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Motivo de queja
      </div>
      <div
        slot="session_state_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado de la sesión
      </div>

      <div
        slot="session_date"
        class="title-size font-bold text-gray-500 text-center"
      >
        Fecha de sesión
      </div>

      <!-- Custom rendering for session_state_name column -->
      <template slot="session_state_name" slot-scope="text, record">
        <SessionsStatusLabel :status="record.session_state_name" />
      </template>

      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div
        slot="actions"
        slot-scope="text, record"
        class="flex flex-row justify-items-center align-items-center space-x-3 justify-center"
      >
        <button
          class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
          @click="goToComplaintDetail(record)"
        >
          <a-icon
            type="eye"
            theme="twoTone"
            two-tone-color="#3366cc"
            :style="{ fontSize: '20px' }"
            class="transition-all group-hover:text-white group-hover:two-tone-color-white"
          />
        </button>
        <template
          v-if="
            record.session_state_name === STATE_SESION_CHAT_AGENDADA ||
            record.session_state_name === STATE_SESION_FINALIZADA ||
            record.session_state_name === STATE_SESION_FINALIZADA_SIN_GESTION
          "
        >
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="viewSessionDetails(record)"
          >
            <a-icon
              type="file-text"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
        <template
          v-if="record.session_state_name === STATE_SESION_CHAT_AGENDADA"
        >
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="accessSession(record)"
          >
            <a-icon
              type="message"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
      </div>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    slots: { title: "codigo_queja" },
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    width: 140,
  },

  {
    slots: { title: "nameEv" },
    dataIndex: "nameEv",
    key: "nameEv",
    width: 100,
  },
  {
    slots: { title: "reason_name" },
    dataIndex: "reason_name",
    key: "reason_name",
    width: 150,
  },

  {
    slots: { title: "session_state_name" },
    dataIndex: "session_state_name",
    key: "session_state_name",
    scopedSlots: { customRender: "session_state_name" }, // Enable custom rendering
    width: 140,
  },
  {
    slots: { title: "session_date" },
    dataIndex: "session_date",
    key: "session_date",
    width: 115,
  },

  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    align: "center",
    width: 130,
  },
];
import {
  STATE_SESION_CHAT_AGENDADA,
  STATE_SESION_FINALIZADA,
  STATE_SESION_FINALIZADA_SIN_GESTION
} from "@/core/utils/constants";

import SessionsStatusLabel from "@/feature/dashboard/complaints_agiliza/presentation/partials/SessionsStatusLabel.vue";
export default {
  components: {
    SessionsStatusLabel,
  },
  props: ["dataSource"],

  data() {
    return {
      columns,
      emptyTemplate: (
        <div style="text-align: center; padding: 20px;">
          <a-icon type="inbox" style="font-size: 48px; " />
          <p
            style="margin-top: 8px; font-size: 18px;"
            class="text-gray-500 font-bold"
          >
            No se encontraron resultados
          </p>
        </div>
      ),
      STATE_SESION_CHAT_AGENDADA,
      STATE_SESION_FINALIZADA,
      STATE_SESION_FINALIZADA_SIN_GESTION
    };
  },
  methods: {
    accessSession(record) {
      this.$emit("accessSession", record);
    },
    changeStateFacilitator(checked, record) {
      this.$emit("changeStateFacilitator", checked, record);
    },
    goToComplaintDetail(record) {
      this.$emit("goToComplaintDetail", record);
    },
    viewSessionDetails(record) {
      this.$emit("viewSessionDetails", record);
    },
  },
};
</script>
